<template>
  <div class="is-flex is-justify-content-center" :key="getStatuslabel">
    <button
    :class="['button mr-0 has-background-white run-timer', 'has-border-'+ getStatusType.color]" v-if="(rowData.form?._id || rowData.form?.id) && !isTemplateOrder"
      v-tooltip="getStatuslabel"
      @mouseleave="hovered = false">
      <i :class="[getStatusType.icon,  'has-text-'+ getStatusType.color]"
        @click="triggerModal"></i>
    </button>
    <VDropdown  placement="left" :shown="isOpen" :autoHide="false" v-else>
      <!-- This will be the popover reference (for the events and position) -->
      <button v-if="showFormAddButton"
      class="is-clickable  button run-timer mr-0 has-border-black-bis" v-tooltip="'Attach QC Form'" >
          <i class="icon-addnew" @click="loadData()"></i>
        </button>
        <span class="is-clickable" v-else-if="!showFormAddButton && isTemplateOrder">
          <i class="icon-edit" @click="loadData()"></i>
        </span>

      <!-- This will be the content of the popover -->
      <template #popper>
        <div class="card has-text-black-bis is-visible">
          <header class="card-header has-background-grey-lighter">
            <h4
              class="card-header-title is-size-3 has-text-black-bis
                has-text-weight-bold is-paddingless"
            >
              Add QC Form To Work Step
            </h4>
          </header>
          <section class="card-content py-4 is-marginless has-background-white">
            <div class="mb-2">
              <em>Work Step</em> {{rowData.name}}
            </div>
            <div class="qc-form-select">
              <h4>
                Choose Manufacton QC Form
              </h4>
              <mf-multi-select
                :options="formList"
                label="name"
                track-by='_id'
                v-model="selectedData.form"
                :allow-empty="false"
              ></mf-multi-select>
            </div>
            <div class="qc-form-select">
              <h4>
                Set Assignee
              </h4>
              <mf-multi-select
                v-model="selectedData.owner"
                :options="listUsers"
                :closeOnSelect="true"
                label="name"
                track-by="_id"
                :multiple="false"
                :hideSelected="false"
                :allow-empty="false"
                group-values="val" group-label="key"
                class="pendo-run-owner-select">
              </mf-multi-select>
            </div>
          </section>
          <footer
            class="card-footer" :class="!isTemplateOrder ? 'is-justify-content-flex-end has-background-grey-lighter' : ''"
          >
            <div v-if="isTemplateOrder && !showFormAddButton" class="column p-0">
              <div class="columns">              
              <div class="column">
              <button class="button is-outlined is-danger"
                @click="removeForm(rowData)" v-if="isOld">
                Remove QA/QC
              </button>
              </div>
              <div class="buttons column is-flex is-justify-content-flex-end">
                <button class="button is-outlined cancel-btn"
                  @click="isOpen = !isOpen">
                  Cancel
                </button>
                <button class="button is-black" @click="attachForm(rowData)"
                  :disabled="isDisabledSaveForm(rowData)">
                  Save
                </button>
              </div>
              </div>
            </div>
            <div class="buttons" v-else-if="showFormAddButton">
              <button class="button is-outlined"  @click="isOpen = !isOpen">
                Cancel
              </button>
              <button @click="linkForm()"
                class="button has-background-black-bis has-text-white"
                :disabled="isAddFormDisabled">
                {{isOld ? 'Save Changes' : 'Add QA/QC Form'}}
              </button>
            </div>
          </footer>
        </div>
        <o-loading
          :full-page="false"
          :active="isLoading"
          :can-cancel="false"
        ></o-loading>
      </template>
    </VDropdown>
    <o-loading
        :full-page="true"
        :active="isLoading"
        :can-cancel="true"
      ></o-loading>
  </div>
</template>

<script>
import { computed, reactive, toRefs } from 'vue';
import { ModalProgrammatic } from '@oruga-ui/oruga-next';
import QaQcmodal from '@/components/modals/QaQcModal.vue';
import Form from '@/models/Form';
import Users from '@/models/Users';
import { isEmpty, set } from 'lodash';
import MfMultiSelect from '../abstract/MfMultiSelect.vue';
import { DialogProgrammatic } from "@/components/Dialog";

export default {
  components: { MfMultiSelect },
  name: 'QaQc-field',
  props: {
    rowData: {
      type: Object,
      default: () => {},
    },
    card: {
      type: Object,
      default: () => {},
    },
    rowField: {
      type: Object,
      default: () => {},
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      isOpen: false,
      formList: [],
      selectedData: {
        form: null,
        owner: null,
      },
      listUsers: [],
      isLoading: false,
      _beforeEdit: _.cloneDeep(props.rowData),
      isOld: false
    });
    const triggerModal = () => {
      ModalProgrammatic.open({
        component: QaQcmodal,
        props: {
          rowData: props.rowData,
          card: props.card,
        },
        events: {
          close: (opt = {}) => {
            if (opt.isOrderPaused || opt.formRemoved || opt.refreshCard) {
              emit('save');
            }
            if (opt.statusChanged) {
              props.rowData.changeQaQcFormStatus(opt.status);
            }
          },
        },
        canCancel: false,
        rootClass: 'modal-sm qa-modal',
      });
    };
    const loadData = async () => {
      state.isOpen = !state.isOpen;
      state.isLoading = true;
      set(props.rowData, '_beforeEdit', _.cloneDeep(props.rowData));
      const comps = props.card.getInvolvedCompanies();
      if (!state.formList.length) {
        const formList = await Form.get({
          formType: 'template',
        });
        state.listUsers = await Users.getGroupedProjectLinkedUsers(comps, props.card.project._id);
        state.formList = formList.data;
      }
      if (props.card.__t === 'ProdTemplates') {
        let users = (await Users.allUsers({ limit: 1000 })).data;
        users = _.filter(users, (user) => user.activated && !user.archived);
        state.listUsers = Users.groupUsers(users);
        if (props.rowData.form && props.rowData.form._id) {
          try {
            state.isLoading = true;
            const { data } = await Form.get({
              formId: props.rowData.form._id,
            });
            const findTemplateForm = _.find(state.formList, {
              _id: data[0].formTemplate
            })
            state.selectedData.form = findTemplateForm || data[0]
            state.selectedData.owner = data[0].owner.user
            state.isOld = true
          } catch (e) {
            console.error(e);
          } finally {
            state.isLoading = false;
          }
        }
      }
      state.isLoading = false;
    };
    const linkForm = async () => {
      if (isEmpty(state.selectedData?.form)) {
        return false;
      }
      state.isLoading = true;
      const reqData = {
        formId: state.selectedData?.form?._id,
        owner: state.selectedData?.owner?._id,
        projectId: props.card.project?._id,
        runId: props.rowData._id,
        orderId: props.card._id,
      };
      const newForm = await Form.attachForm(reqData);
      props.rowData.addQaQcForm(newForm);
      state.isOpen = false;
      state.isLoading = false;
      emit('addedForm', { form: newForm });
    };
    const getStatusType = computed(() => {
      const status = {
        notStarted: { icon: 'icon-qcnotstarted', color: 'grey-dark' },
        inspect: { icon: 'icon-qcinspect', color: 'info' },
        inProgress: { icon: 'icon-qcinprogress', color: 'link'},
        pass: { icon: 'icon-qcsignature', color: 'success' },
        fail: { icon: 'icon-qcfail', color: 'danger' },
        complete: { icon: 'icon-qcpass', color: 'success' },
      };
      const currentStatus = status[props.rowData.formStatus];
      if (!isEmpty(currentStatus)) {
        return currentStatus;
      }
      return '';
    });

    const getStatuslabel = computed(() => {
      const status = {
        notStarted: 'QC Not Started',
        inspect: 'QC Inspection',
        inProgress: 'QC In Progress',
        pass: 'QC Signature Required',
        fail: 'QC Fail',
        complete: 'QC Complete',
      };
      return status[props.rowData.formStatus] || '';
    });

    const showFormAddButton = computed(() => {
      if (isTemplateOrder.value) {
       if (!props.rowData.form || !props.rowData.form._id
          || (state._beforeEdit.form && !state._beforeEdit.form._id)) {
          return true
        } else {
          return false
        }
      }
      if ((props.rowData.completed && !props.rowData.form?._id)) {
        return false;
      }
      return true;
    });
    const isAddFormDisabled = computed(() => isEmpty(state.selectedData.form) || isEmpty(state.selectedData.owner));

    const isTemplateOrder = computed(() => {
      return props.card.__t === 'ProdTemplates'
    })

    const removeForm = (run) => {
      state.isOpen = false
      DialogProgrammatic.confirm({
        title: 'Remove QA/QC From Work Step',
        message: `Are you sure you want to QA/QC from work step ${run.name}?`,
        okButton: "Delete",
        cancelButton: "Cancel",
        onConfirm: async () => {
          try {
            state.isLoading = true
            await Form.archive(run.form._id);
            emit('formRemoved');
          } catch (e) {
            console.error('Error: ', e)
          } finally {
            state.isLoading = false
          }
        },
      })
    }

    const isDisabledSaveForm = (run) => {
      if (state.isOld) {
        let isDisabled = true;
        if (run.form._id !== state._beforeEdit.form?._id) isDisabled = false;
        else if (state.selectedData.owner && isDisabled
          && state.selectedData.owner._id !== state._beforeEdit.owner.user._id) {
          isDisabled = false;
        }
        return isDisabled;
      }
    }

    return {
      triggerModal,
      ...toRefs(state),
      loadData,
      linkForm,
      getStatusType,
      getStatuslabel,
      showFormAddButton,
      isAddFormDisabled,
      isTemplateOrder,
      removeForm,
      isDisabledSaveForm
    };
  },
};
</script>

<style scoped>
.is-flex .button.mr-0 {
  margin-right: 0 !important;
}
</style>
